/**
* 登录基础类
*/
import '@common/polyfill/src/Object.assign'
// import { domain } from '@finance/domain'
// import url from '@common/url'
import cookie from 'js-cookie'
// import ajax from '@finance/ajax'

import { isLoginCookie, callbackHandler, mixins, getUserProfile } from '../utils'
import { loginTypes, accountTypes } from '../dict'
// import { openAccount } from '../account/account'
import { getUserIds, setLoginCookie, setUserIdCookie, clearCookies } from '@finance/login-cookie'

// 类型匹配
const matchType = (refer, values) => {
  const _refer = (typeof refer === 'string') ? refer.toLowerCase() : refer 
  const _values = Array.isArray(values) ? values : [values]
  return _values.indexOf(_refer) !== -1
}

// const COOKIE_EXPIRE_TIME = 30 // 单位天

@mixins({ loginTypes, accountTypes })
class BaseAuth {
  // 是否命中客户端
  isClientHit = false
  // 是否依赖isLogin cookie
  isRelyOnIsLoginCookie = true
  // 配置
  options = {
    type: loginTypes.normal, // 登录类型
    accountType: accountTypes.none, // 开户类型
    forwardUrl: window.location.href, // web登录或开户后的跳转url
    origin: '', // 开户的渠道标识
    currentView: false, // 是否在当前窗口打开开户url
    isNeedUserData: false, // 是否强制需要用户数据
    isShowAccountCustodyDialog: true, // 存管账户是否先弹窗提示
    webLoginType: 'ssj', // web登录时调用的页面，【ssj:随手记，sgj:随管家】
    success: () => { }, // 成功回调
    error: () => { }, // 失败回调
    cancel: () => { } // 取消登录回调
  }
  // 登录类型
  loginType = {}
  // 需要开户类型
  accountType = {}
  // 用户信息缓存
  userInfoCache = {}
  constructor(options) {
    this.options = Object.assign(this.options, options)
    this.loginType = {
      normal: matchType(this.options.type, [0, this.loginTypes.normal]),
      force: matchType(this.options.type, [1, this.loginTypes.force]),
      silent: matchType(this.options.type, [2, this.loginTypes.silent]),
      tokenExpire: matchType(this.options.type, [3, this.loginTypes.tokenExpire]),
      tokenError: matchType(this.options.type, [4, this.loginTypes.tokenError]),
    }
    this.accountType = {
      none: matchType(this.options.accountType, [1, this.accountTypes.none]),
      custody: matchType(this.options.accountType, [2, this.accountTypes.custody]),
      acc: matchType(this.options.accountType, [3, this.accountTypes.acc]),
      cardbull: matchType(this.options.accountType, [4, this.accountTypes.cardbull]),
    }
  }
  // 重设登录类型
  // 用于登录失败时调用
  resetLoginType(key) {
    Object.keys(this.loginType).forEach((item) => {
      this.loginType[item] = false
    })
    try {
      this.loginType[key] = true
    } catch (e) {
      console.error(e)
    }
  }
  /**
   * 通过token获取suid、ssjid并且写入cookie数据
   * @param {*} params 
   * @param {*} callbacks 
   */
  async requestLoginApi(params, callbacks = { tokenExpire() {}, tokenError() {} }) {
    console.log('requestLoginApi:', params)
    await setLoginCookie(params)
    this.userInfoCache = params
    // 判断是否获取ssjid、suid
    setTimeout(async() => {
      if (!!params.token) {
        getUserIds({ token: params.token, type: params.tokenType })
          .then(async(result) => {
            sessionStorage.setItem('ssjid', result.ssjid || '')
            sessionStorage.setItem('suid', result.suid || '')
            await setUserIdCookie(result)
            this.requestLoginApiSuccessCallback()
          })
          .catch(async(err) => {
            console.error('getUserIds Error:', err)
            const response = err.response || {}
            const {code, message} = response.data || {}
            
            if ((code && (code === 65280 || code === 65283)) || /token|Token/.test(message)) {
              clearCookies(['ssj_id', 'ssj_uid', 'isLogin', 'ssj_token', 'ssj_token_type'])
              callbacks.tokenExpire()
            } else {
              this.requestLoginApiSuccessCallback()
            }
          })
      } else {
        console.info('getUserIds: token is null')
        clearCookies(['ssj_id', 'ssj_uid', 'isLogin', 'ssj_token', 'ssj_token_type'])
        this.requestLoginApiSuccessCallback()
      }
    }, 0)
  }
  // 登录成功或者退出登录成功
  async requestLoginApiSuccessCallback() {
    // 登录成功，判断是否需要用户信息和开户信息
    const isLogin = isLoginCookie()
    if (isLogin && this.options.isNeedUserData) {
      try {
          const userData = await getUserProfile()
          sessionStorage.setItem('userDataCache', JSON.stringify(userData))
          callbackHandler(this.options.success, { isLogin, ...userData, ...this.userInfoCache })
      } catch (error) {
        callbackHandler(this.options.success, { isLogin, ...this.userInfoCache })
      }
    } else {
      callbackHandler(this.options.success, { isLogin, ...this.userInfoCache })
    }
  }
  // 检验cookie
  checkIsLogin() {
    if (isLoginCookie() && this.isRelyOnIsLoginCookie) {
      return true
    }
    return false
  }
  // static setOAuth2Token(token) {
  //   if (token) {
  //     cookie.set('ssj_token', token, { domain: url('domain'), expires: COOKIE_EXPIRE_TIME })
  //   }
  // }
}

export default BaseAuth
